import { render } from "./SocialThreads.vue?vue&type=template&id=12254af2"
import script from "./SocialThreads.vue?vue&type=script&lang=js"
export * from "./SocialThreads.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__